export default __webpack_public_path__ + "static/media/bridge-hover.6476732d.svg";